import NewGroupForm from './NewGroupForm'
import { useGetUsersQuery } from '../users/usersApiSlice'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'
import { useGetCompaniesQuery } from '../companies/companiesApiSlice'

const NewGroup = () => {
    useTitle('techGroups: New Group')

    const { companies } = useGetCompaniesQuery("companiesList", {
        selectFromResult: ({ data }) => ({
            companies: data?.ids.map(id => data?.entities[id])
        }),
    })

    if (!companies?.length) return <PulseLoader color={"#FFF"} />

    const content = <NewGroupForm companies={companies} />

    return content
}
export default NewGroup